import Button from "@/components/atoms/button";

interface IProps {
    isWritting: boolean;
    isSendCheckBtnDisabled: boolean;
    onClickSendCheckBtn: () => void;
    onClickSendCancelBtn: () => void;
}

const SendCheckBtn = ({isWritting, isSendCheckBtnDisabled, onClickSendCheckBtn, onClickSendCancelBtn}: IProps) => {
    return (
        <div className="btn-area-trxn-snd send_check_btn" style={{display: isWritting ? 'flex' : 'none'}}>
            <Button caption="취소" onClick={onClickSendCancelBtn} className="cancel-button l-button" />
            <Button caption="다음" onClick={onClickSendCheckBtn} className="next-button l-button" disabled={isSendCheckBtnDisabled} />
        </div>
    );
};

export default SendCheckBtn;